import { provideComponent, useDataItem, useDataScope } from "scrivito"
import { useEvent } from "shared/lib/useEvent"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"

import { getShareLinkFromShareID } from "entities/projects/model/useGetProjectShareLink"
import { useCreateShareLinkMutation } from "features/project-sharing/graphql/mutations.generated"

import { CreateOpportunityButtonWidget } from "./CreateOpportunityButtonWidgetClass"

provideComponent(CreateOpportunityButtonWidget, ({ widget }) => {
  const project = useDataItem("Project")
  const scope = useDataScope("Opportunity")
  const [createShareLink] = useCreateShareLinkMutation()

  const handleCreate = useEvent(async () => {
    const projectID = project?.get("projectId") as string | null | undefined
    const keyword = project?.get("title")

    if (projectID) {
      const shareLinkResult = await createShareLink({
        variables: {
          id: projectID,
          input: { id: projectID }
        }
      })

      return scope?.create({
        external_id: projectID,
        keyword,
        description: getShareLinkFromShareID(shareLinkResult.data?.shareLink.id)
      })
    }
    return undefined
  })

  return (
    <Button
      variant={ButtonVariant.PRIMARY}
      onClick={handleCreate}
      className="create-opportunity-button"
    >
      {widget.get("text")}
    </Button>
  )
})
